export default {
  noResults: "No results to show"
};
